import { useCallback, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { SearchFilterSortProps } from './SearchFilterSortUpload.props';
import { useStyles } from './SearchFilterSortUpload.styles';
import { Box, Button } from '@material-ui/core';
import { Icon, Menu, OptionItem, TextField } from '@components';
import { variables } from '@styles';
import { FILTER_SORT_OPTIONS } from './SearchFilterSortUpload.const';

export function SearchFilterSortUpload({
  className,
  control,
  filterSortClassName,
  placeholder = '',
  resetSearchTerm = false,
  searchBarClassName,
  showFilterSort = false,
  showUpload = false,
  suggestions,
  uploadButtonClassName,
  onFilterSortChange,
  onKeyUp,
  onSearchTermChange,
  onUploadClick,
  setResetSearchTerm,
  setSearchValue,
}: SearchFilterSortProps): JSX.Element {
  const styles = useStyles();
  const [options, setOptions] = useState<OptionItem[]>(FILTER_SORT_OPTIONS);

  const handleFilterSortChange = useCallback(
    (item: OptionItem) => {
      const newOptions = options.map((element) => {
        if (element.id === item.id) {
          return { ...element, active: true };
        } else {
          if (element.subOptions?.length) {
            const subOptions = element.subOptions?.map((sub) => {
              if (sub.id === item.id) {
                return { ...sub, active: true };
              } else if (sub.type === item.type) {
                return { ...sub, active: false };
              }
              return sub;
            });
            return { ...element, subOptions };
          }
          if (element.type === item.type) {
            return { ...element, active: false };
          }
          return element;
        }
      });
      setOptions(newOptions);

      if (onFilterSortChange) {
        onFilterSortChange(item);
      }
    },
    [options, onFilterSortChange],
  );

  useEffect(() => {
    if (resetSearchTerm) {
      // Reset the keyword field in the form
      setSearchValue?.('keyword', '');
      // onSearchTermChange('', false);

      if (setResetSearchTerm) {
        setResetSearchTerm(false);
      }
    }
  }, [onSearchTermChange, resetSearchTerm, setResetSearchTerm, setSearchValue]);

  return (
    <Box className={`${styles.container} ${className || ''}`}>
      <Controller
        name="keyword"
        control={control}
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            className={`${styles.searchBar} ${searchBarClassName || ''}`}
            size="small"
            inputRef={ref}
            placeholder={placeholder}
            suggestions={suggestions}
            onChange={onSearchTermChange}
            onKeyUp={onKeyUp}
            icon="SearchOutline"
          />
        )}
      />
      {showFilterSort && (
        <Box className={`${styles.filterSortMenu} ${filterSortClassName || ''}`}>
          <Controller
            name="sortBy"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <Menu
                {...field}
                options={options}
                onClick={handleFilterSortChange}
                icon={<Icon.ArrowDown height="16" width="16" />}
                disableRipple
              />
            )}
          />
        </Box>
      )}
      {showUpload && (
        <Button
          className={`${styles.uploadButton} ${uploadButtonClassName || ''}`}
          onClick={onUploadClick}
          disableRipple
          variant="contained"
          color="primary"
        >
          <Icon.Upload fill={variables.colorV2.button.icon.fill.default} height="20" width="20" />
        </Button>
      )}
    </Box>
  );
}
